import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import keycloak from "../keycloak";

// for DEV deployment
export const baseUrl = "https://jmareports.com/home/api";
// export const baseUrl = "https://www.jma-reports.com/home/api";
// // PRODUCTION URL
// export const baseUrl = "/home/api";
// LOCAL URL
// export const baseUrl = "/home/api";

const customBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: async (headers, { type }) => {
    headers.set("Accept", "application/json");
    await keycloak.updateToken(30).catch(() => {
      // If refresh fails, the existing token (if any) is still used.
    });

    if (keycloak.token) {
      headers.set("Authorization", `Bearer ${keycloak.token}`);
    }

    return headers;
  },
});

export const baseQuery = async (args, api, extraOptions = {}) => {
  try {
    const response = await customBaseQuery(args, api, extraOptions);
    return {
      data: response?.data?.d ?? response.data,
      meta: response.meta,
      error: response?.error?.data?.error?.message?.value,
    };
  } catch (error) {
    console.log("error", error);
  }
};